import { ChangeDetectorRef, DOCUMENT, Inject, Injectable, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, debounce, debounceTime, fromEvent, map, of, tap } from "rxjs";
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ToolbarService {

    private toolbarContent = new BehaviorSubject<TemplateRef<any>>(null);
    toolbarContent$ = this.toolbarContent.asObservable().pipe(debounceTime(1));

    toolbarVisible$ = this.toolbarContent$.pipe(
        map(content => !!content)
    );

    setToolbar(content: TemplateRef<any>) {
        this.toolbarContent.next(content);
    }

    clearToolbar() {
        this.toolbarContent.next(null);
    }

    constructor(

    ) {
    }




}
